import { evalData } from '@ow/utils'

export const mergeData = (arr1 = [], arr2 = []) => {
  let res = []
  if (!arr1.length) return res
  res = arr1.map((obj) => {
    const index = arr2.findIndex((el) => el.objectId === obj.objectId)
    const obj2 = index !== -1 ? arr2[index] : obj
    return {
      ...obj2,
    }
  })
  return res
}

/**
 * 根据filter生成额外的过滤条件
 * 目前在朝阳考核统计使用
 * @param {*} filters
 */
export const getFiltersAfterproducts = (filters) => {
  const result = []
  if (!filters || !filters.queries) return filters
  filters.queries.forEach(({ value, afterproduct }) => {
    if (!afterproduct) return
    result.push(evalData(afterproduct, value))
  })

  return { ...filters, queries: filters.queries.concat(result) }
}
